import { FormattedDate, FormattedMessage } from 'react-intl';
import { useState, useEffect, Fragment, useMemo } from 'react';
import cls from 'classnames';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { motion, Variants } from 'framer-motion';
import { allNews } from 'contentlayer/generated';
import { handleNewsTitle } from 'src/utils';
import New from './New';
import styles from './index.module.scss';
import { formatImg } from 'src/components/common/Intl';
import NewCp from './NewCp';
import { categories } from '@/constants/news/category';

const newsContent = [
  {
    imgSrc: 'png',
    label: 1,
    title: 'Youdao-Ads-releases-new-brand-positioning',
  },
  {
    imgSrc: 'png',
    label: 2,
    title:
      'social entertainment APP: How to achieve high-ROI digital marketing beyond Chinese market',
  },
  {
    imgSrc: 'png',
    label: 3,
    title:
      'Big news! Youdao Ads releases the Internet marketing report of Thailand market Deep Dive: explore the internet marketing in Thailand market',
  },
  {
    imgSrc: 'png',
    label: 3,
    title:
      'Big news! Youdao Ads releases the Internet marketing report of Indonesia market Deep Dive: explore the internet marketing in Thailand market',
  },
  {
    imgSrc: 'jpg',
    label: 1,
    title:
      'Exclusive interview of Nikkei News: Youdao Ads helps Chinese game makers go global',
  },
  {
    imgSrc: 'jpg',
    label: 1,
    title:
      'Youdao Ads strikes a strategic cooperation with Guangdong University of Foreign Studies International Students Institute',
  },
];

const newsMoreContent = [
  {
    imgSrc: 'png',
    label: 2,
    title:
      'Youdao Ads conducts the 2021 Overseas Game Influencer Marketing Conference',
  },
  {
    imgSrc: 'jpg',
    label: 3,
    title:
      "Youdao Ads releases China's first overseas KOL marketing report of game industry",
  },
];

const listVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.2,
    },
  },
};

const itemVariants: Variants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

const NewsComp: React.FC = () => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const router = useRouter();
  const { locale } = router;
  const allNewsMemo = useMemo(
    () => allNews.sort((a, b) => (a.time > b.time ? -1 : 1)),
    [allNews]
  );

  const handleShowMore = () => {
    setShowMore(true);
  };

  useEffect(() => {
    setShowMore(false);
  }, [router]);

  return (
    <Fragment>
      <div className={styles.container}>
        <div className={styles.title}>
          <div className={styles.sub__title}>
            <FormattedMessage
              id="news.title.sub_title"
              defaultMessage="News"
              values={{
                myImg: formatImg,
              }}
            />
          </div>
          <div className={cls(styles.main__title, 'font')}>
            <FormattedMessage
              id="news.title.main_title"
              defaultMessage="News"
            />
          </div>
        </div>
        <motion.ul
          className={cls(styles.content, { [styles.show__more]: showMore })}
          variants={listVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {allNewsMemo.slice(0, 6).map((item) => (
            <motion.li key={item.slug} variants={itemVariants}>
              <Link href={`/news/a/${item.key}`}>
                <a>
                  <NewCp
                    {...item}
                    title={locale === 'en-US' ? item.enTitle : item.title}
                    // category={categories[item.category][locale]}
                    time={
                      <FormattedDate
                        value={item.time}
                        year="numeric"
                        month="long"
                        day="2-digit"
                      />
                    }
                  />
                </a>
              </Link>
            </motion.li>
          ))}

          {showMore &&
            allNewsMemo.slice(6).map((item) => (
              <motion.li
                key={item.slug}
                initial={{ y: 20, opacity: 0 }}
                animate={{
                  y: 0,
                  opacity: 1,
                }}
              >
                <Link href={`/news/a/${item.key}`}>
                  <a>
                    <NewCp
                      {...item}
                      title={locale === 'en-US' ? item.enTitle : item.title}
                      // category={categories[item.category][locale]}
                      time={
                        <FormattedDate
                          value={item.time}
                          year="numeric"
                          month="long"
                          day="2-digit"
                        />
                      }
                    />
                  </a>
                </Link>
              </motion.li>
            ))}

          {showMore ? (
            [...newsContent, ...newsMoreContent].map((item, index) => (
              <motion.li
                key={index}
                initial={{ y: 20, opacity: 0 }}
                animate={{
                  y: 0,
                  opacity: 1,
                }}
              >
                <Link
                  href={`/news/${handleNewsTitle(item.title)}`}
                  key={index + 1}
                >
                  <a>
                    <New
                      imgSrc={`/overseacdn/homepage/static/images/news/head${
                        index + 1
                      }.${item.imgSrc}`}
                      label={`news.newList.label${item.label}`}
                      title={`news.newList.title${index + 1}`}
                      time={`news.newList.time${index + 1}`}
                    />
                  </a>
                </Link>
              </motion.li>
            ))
          ) : (
            <a className={styles.more__button} onClick={handleShowMore}>
              <FormattedMessage
                id="news.newList.showMore"
                defaultMessage="Read More"
              />
            </a>
          )}
        </motion.ul>
      </div>
    </Fragment>
  );
};

export default NewsComp;
